import {Component, Input, OnInit} from '@angular/core';
import {TYPE} from '../../models/type.enum';

@Component({
  selector: 'cmp-button-icon',
  template: `<button type="button"
        *ngIf="type && icon"
        class="btn btn-{{type}} btn-link rounded-circle btn-sm">
        <i [class]="icon"></i>
  <ng-content></ng-content>
</button>
`,
  styles: [`.rounded-circle{width:27px;height:27px;padding:0}.btn-rounded-light{background-color:#f8f9fa}.btn-rounded-light:hover{background-color:#e2e6ea}.btn-rounded-light i{color:#327abd}.btn-rounded-regular{background-color:#e2e6ea}.btn-rounded-regular:hover{background-color:#ddd}.btn-rounded-regular:hover i{color:#327abd}`]
})
export class ButtonCircleComponent implements OnInit {

  @Input() type: TYPE = TYPE.PRIMARY;
  @Input() icon = '';

  constructor() {

  }

  ngOnInit() {
  }

}
